export const NumberFixed = (_number, digits = 2) => {
  if (_number === null) return 0
  if (_number === "") return 0
  if (_number === undefined) return 0

  const numberParsed = Number(_number)

  return Number(numberParsed.toFixed(digits))
}
